import { FC } from 'react';

import { useTranslation } from '@mint-lib/i18n';

import { Dialog, Typography } from '@myn/mui';

import { useDeleteMediaPlanRowMutation } from '../../api/mediaPlansApiSlice.js';
import type { RowToRemoveObject } from '../../pages/Builder/types.js';
import { getRemoveModalText } from '../../utils/addRowsPanel.js';

type Props = {
  rowToRemove: RowToRemoveObject | null;
  setRowToRemove: (row: RowToRemoveObject | null) => void;
};
const DeleteRowModal: FC<Props> = ({ rowToRemove, setRowToRemove }) => {
  const { t } = useTranslation('@myn/planning');

  const [deleteRow] = useDeleteMediaPlanRowMutation();

  const handleCloseRemoveModal = () => setRowToRemove(null);

  const handleRemoveRow = async () => {
    if (!rowToRemove) {
      return;
    }
    deleteRow({ rowId: rowToRemove.rowId });
    handleCloseRemoveModal();
  };

  const removeModalText = getRemoveModalText(rowToRemove, t);

  return (
    <Dialog
      size="s"
      title={t('Delete this row?')}
      open={!!rowToRemove}
      onClose={handleCloseRemoveModal}
      icon="WarningAltFilled"
      iconProps={{
        color: 'error',
      }}
      submitButtonProps={{
        'aria-label': 'delete row',
        label: t('Yes, delete'),
        color: 'error',
        size: 'large',
        variant: 'contained',
        onClick: handleRemoveRow,
      }}
      cancelButtonProps={{
        'aria-label': 'cancel delete',
        label: t('Cancel'),
        color: 'primary',
        size: 'large',
        variant: 'text',
        onClick: handleCloseRemoveModal,
      }}
    >
      <Typography variant="bodyShort01">{removeModalText}</Typography>
    </Dialog>
  );
};

export default DeleteRowModal;
